import { useCallback, useState } from 'react';
import { useIntl } from 'react-intl';
import { usePopup } from 'Util/usePopup';

const DEBUG = !['production', 'test', 't'].includes(process.env.NODE_ENV);

const ERROR_MESSAGES = {
  'error.worklogDetail.empty': 'error.worklogDetail.empty',
  'error.INVALID_DATE': 'error.INVALID_DATE',
  common: 'common.error',
  'File too large': 'err.image.FileTooLarge',
  'error.invited.customer': 'err.invited.customer',
};

export const useError = () => {
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const { formatMessage } = useIntl();
  const { showOneButtonExclamationDialog } = usePopup();

  const getErrorAlertMessage = useCallback(
    err => {
      if (ERROR_MESSAGES[err]) {
        return formatMessage({ id: ERROR_MESSAGES[err] });
      }
      if (DEBUG && typeof err?.response?.data?.errors?.message?.err === 'string') {
        console.log(err.response.data.errors.message.err, 'err');
      }
      if (DEBUG && typeof err?.response?.data?.errors?.message === 'string') {
        console.log(err.response.data.errors.message, 'err');
      }
      if (DEBUG && typeof err?.response?.data) {
        console.log(err.response.data, 'err');
      }
      return formatMessage({ id: 'error.defaultError' });
    },
    [formatMessage]
  );

  const startError = useCallback(
    err => {
      setShowAlert(true);
      setAlertMessage(getErrorAlertMessage(err));
    },
    [getErrorAlertMessage]
  );

  const startErrorWithMessage = useCallback(message => {
    setShowAlert(true);
    setAlertMessage(message);
  }, []);

  const endError = useCallback(() => {
    setShowAlert(false);
    setAlertMessage('');
  }, []);

  const showErrorPopup = useCallback(
    ({ id, text, onClose = () => {} }) => {
      if (!id && !text) return;
      showOneButtonExclamationDialog({
        title: id ? id : text,
        needIntl: id ? true : false,
        onClose,
      });
    },
    [showOneButtonExclamationDialog]
  );

  return { getErrorAlertMessage, startError, startErrorWithMessage, endError, showAlert, alertMessage, showErrorPopup };
};
